var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4Upcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#DA5042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2015 23.151L41.1133 14.2629L25.9068 36.6554L38.995 45.5434L54.2015 23.151Z",
    fill: "#302322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3435 41.6549L31.2324 39.5422L25.8475 47.4718L28.9586 49.5845L34.3435 41.6549Z",
    fill: "#EEC98A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1584 58.8656L19.4123 56.9941C19.276 56.8995 19.1752 56.762 19.1261 56.6035C19.077 56.445 19.0823 56.2746 19.1412 56.1195L23.2779 45.791C23.317 45.6889 23.3787 45.5971 23.4583 45.5222C23.538 45.4473 23.6335 45.3914 23.7377 45.3586C23.842 45.3258 23.9523 45.317 24.0605 45.3328C24.1686 45.3486 24.2718 45.3886 24.3623 45.4499L31.1052 50.0326C31.195 50.0948 31.2698 50.1762 31.3242 50.2709C31.3785 50.3657 31.4111 50.4713 31.4195 50.5802C31.4278 50.6891 31.4118 50.7985 31.3726 50.9005C31.3333 51.0024 31.2719 51.0943 31.1926 51.1695L23.1029 58.7957C22.9774 58.9138 22.815 58.9853 22.6431 58.998C22.4711 59.0107 22.3 58.964 22.1584 58.8656Z",
    fill: "#EEC98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8948 20.3991L42.6851 10.7495C41.3985 9.87579 39.6483 10.2089 38.7759 11.4935C37.9035 12.7782 38.2393 14.5279 39.5259 15.4017L53.7356 25.0513C55.0222 25.925 56.7725 25.5919 57.6448 24.3073C58.5172 23.0226 58.1814 21.2729 56.8948 20.3991Z",
    fill: "#302322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1975 42.0295L27.9879 32.3799C26.7012 31.5062 24.951 31.8393 24.0786 33.1239C23.2062 34.4086 23.542 36.1583 24.8287 37.032L39.0383 46.6816C40.3249 47.5554 42.0752 47.2223 42.9476 45.9376C43.82 44.653 43.4842 42.9033 42.1975 42.0295Z",
    fill: "#302322"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1263 22.1687C43.4329 21.7171 43.3155 21.1025 42.8639 20.7959C42.4124 20.4893 41.7978 20.6068 41.4912 21.0583L33.63 32.6343C33.3234 33.0859 33.4409 33.7005 33.8924 34.0071C34.3439 34.3137 34.9585 34.1963 35.2651 33.7447L43.1263 22.1687Z",
    fill: "#C2D3DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7904 25.3215C48.097 24.87 47.9795 24.2554 47.528 23.9488C47.0765 23.6421 46.4619 23.7596 46.1553 24.2111L38.2941 35.7872C37.9874 36.2387 38.1049 36.8533 38.5564 37.1599C39.008 37.4666 39.6226 37.3491 39.9292 36.8976L47.7904 25.3215Z",
    fill: "#C2D3DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Upcoming);
export default __webpack_public_path__ + "static/media/step4-upcoming.492bffd8dcfb160efa0997ac98f5015c.svg";
export { ForwardRef as ReactComponent };